import { render, staticRenderFns } from "./WhatsappEventsReasonsTable.vue?vue&type=template&id=4bae08a8&scoped=true&"
import script from "./WhatsappEventsReasonsTable.vue?vue&type=script&lang=js&"
export * from "./WhatsappEventsReasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEventsReasonsTable.vue?vue&type=style&index=0&id=4bae08a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae08a8",
  null
  
)

export default component.exports